// @ts-nocheck
// todo
import { ConfirmSwal, ErrorSwal } from '@vendor/libs/sweetalert2/sweetalert2';
import Utils from '@vendor/js/utils';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Modal } from 'bootstrap';
import { Spinner } from '@vendor/js/spinner';
import { Handlebars } from '@vendor/libs/handlebars/handlebars';
import Cookies from 'js-cookie';
const Common = {
    init: () => {
        window._formHiddenElements = [];
        window._buttonsToNotPreventForConfirmation = [];
        $('body').on('click', '[data-app-confirm_text]', function (e) {
            if (!window._buttonsToNotPreventForConfirmation.includes(this)) {
                e.preventDefault();
                ConfirmSwal.fire({
                    text: $(this).attr('data-app-confirm_text'),
                }).then((response) => {
                    if (response.isConfirmed) {
                        window._buttonsToNotPreventForConfirmation = [
                            ...window._buttonsToNotPreventForConfirmation,
                            this,
                        ];
                        $(this).trigger('click');
                    }
                });
            }
            else {
                window._buttonsToNotPreventForConfirmation =
                    window._buttonsToNotPreventForConfirmation.filter((b) => b != this);
                if ($(this).is('a')) {
                    window.location = $(this).attr('href');
                }
            }
        });
        // expose to global object
        window.Common = Common;
    },
    /**
     * Fill form element with some data
     * @param form
     * @param name
     * @param value
     */
    fillFormElement: (form, name, value) => {
        let elements = $(form).find(`[name="${name}"]`);
        if (name.includes('[*]')) {
            name = name.split('[')[0];
            elements = $(form).find('[name^="' + name + '"]');
        }
        elements.each(function () {
            let element = $(this);
            switch (element.prop('nodeName')) {
                case 'SELECT':
                    if (value && typeof value == 'object') {
                        element.empty();
                        for (let item of value) {
                            element.append(`<option value="${item.id}">${item.name}</option>`);
                        }
                        break;
                    }
                    if (element.hasClass('tomselected')) {
                        element[0].tomselect.setValue(value);
                    }
                    else {
                        element.val(value).change();
                    }
                    break;
                case 'INPUT':
                    if (element.data('type') === 'date' ||
                        element.data('type') === 'datetime') {
                        let fp = element[0]._flatpickr;
                        if (fp) {
                            fp.setDate(value);
                        }
                    }
                    if (element.attr('type') === 'checkbox') {
                        element.prop('checked', value).change();
                        break;
                    }
                    element.val(value);
                    break;
                default:
                    element.val(value);
            }
        });
    },
    /**
     * Fill data element with some data
     * @param parent
     * @param name
     * @param value
     */
    fillDataElement: (parent, name, value) => {
        $(parent)
            .find('[data-app-fill="' + name + '"]')
            .text(value);
    },
    /**
     * Fill data elements with some data
     * @param parent
     * @param data
     */
    fillData: (parent, data) => {
        for (let name in data) {
            Common.fillDataElement(parent, name, data[name]);
        }
    },
    /**
     * Hide form element
     * @param form
     * @param name
     */
    hideFormElement: (form, name, disable = true) => {
        let element = $(form).find(`[name="${name}"]`);
        let container = element.closest('.input-container');
        let uniqueName = $(form).attr('id') + '_' + name;
        if (disable) {
            let index = window._formHiddenElements.findIndex((el) => el.name === uniqueName);
            if (index === -1) {
                window._formHiddenElements = [
                    ...window._formHiddenElements,
                    {
                        name: uniqueName,
                        disabled: element.is(':disabled'),
                    },
                ];
            }
            container.find(`[name="${name}"]`).attr('disabled', true);
        }
        if (container.parent().is('[class*="col-"]')) {
            container.parent().hide();
        }
        else {
            container.hide();
        }
    },
    /**
     * Show form element
     * @param form
     * @param name
     */
    showFormElement: (form, name, enable = true) => {
        let element = $(form).find(`[name="${name}"]`);
        let container = element.closest('.input-container');
        let uniqueName = $(form).attr('id') + '_' + name;
        if (enable) {
            let disabledObject = window._formHiddenElements.find((el) => el.name === uniqueName);
            let disabled = disabledObject ? disabledObject.disabled : false;
            container.find(`[name="${name}"]`).attr('disabled', disabled);
            window._formHiddenElements = window._formHiddenElements.filter((el) => el.name !== uniqueName);
        }
        if (container.parent().is('[class*="col-"]')) {
            container.parent().show();
        }
        else {
            container.show();
        }
    },
    setupModalCancelAlert: (element, onCancel = null) => {
        const modal = new bootstrap.Modal(element);
        // disable modal closing..
        modal._config.backdrop = false;
        modal._config.keyboard = false;
        const name = $(element).attr('id').replace('_modal', '');
        // Cancel button handler
        const cancelButton = element.querySelector('[data-app-' + name + '_modal-action="cancel"]');
        cancelButton.addEventListener('click', (e) => {
            e.preventDefault();
            Swal.fire({
                text: 'Czy na pewno chcesz anulować?',
                icon: 'warning',
                showCancelButton: true,
                reverseButtons: true,
                buttonsStyling: false,
                confirmButtonText: 'Tak',
                cancelButtonText: 'Nie',
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-warning-light me-2',
                },
            }).then(function (result) {
                if (result.isConfirmed) {
                    if (onCancel) {
                        onCancel();
                    }
                    modal.hide();
                }
            });
        });
        // Close button handler
        const closeButton = element.querySelector('[data-app-' + name + '_modal-action="close"]');
        closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            Swal.fire({
                text: 'Czy na pewno chcesz anulować?',
                icon: 'warning',
                showCancelButton: true,
                reverseButtons: true,
                buttonsStyling: false,
                confirmButtonText: 'Tak',
                cancelButtonText: 'Nie',
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-warning-light',
                },
            }).then(function (result) {
                if (result.isConfirmed) {
                    if (onCancel) {
                        onCancel();
                    }
                    modal.hide();
                }
            });
        });
    },
    /**
     * Handle form inside modal
     * @param {String} name
     * @param {Object} [options]
     * @param {String} [options.question] Question before deletion
     * @param {String} [options.successMessage] Success message
     * @param {Function} [options.onSuccess] On success callback
     * @param {Function} [options.onLoadData] On load data callback
     * @param {Function} [options.onModalShow] On modal show callback
     * @param {Boolean} [options.loadData] Should load data from server
     * @param {String} [options.loadDataUrl] Url to get the data
     * @param {Boolean} [options.loadDataUrlReplaceId] Should replace "ID" in Url
     * @param {Array} [options.loadDataMap] Map of keys to be replaced, eg. [{ fetched: 'car_id', real: 'id' }]
     * @param {Boolean} [options.loadDataMapWithRegular] Should use mapped properties as well as regular
     * @param {Boolean} [options.loadDataGetUrlFromButton] Should use form url from button
     * @param {Boolean} [options.submitDataGetUrlFromButton] Should use form submit url from button
     * @param {Function} [options.getCustomData] Custom post data
     */
    handleModalForm: (name, options) => {
        options = Utils.setDefaults(options, {
            successMessage: 'Pomyślnie wykonano polecenie!',
            loadData: false,
            loadDataUrl: null,
            loadDataUrlReplaceId: false,
            loadDataMap: null,
            loadDataMapWithRegular: false,
            loadDataGetUrlFromButton: false,
            submitDataGetUrlFromButton: false,
            getCustomData: null,
            onSuccess: (response) => {
                if (response && response.data && response.data.redirectTo) {
                    window.location = response.data.redirectTo;
                    return;
                }
                window.location.reload();
            },
            onLoadData: null,
            onModalShow: null,
        });
        const element = document.getElementById(`${name}_modal`);
        if (!element) {
            return;
        }
        const form = element.querySelector(`#${name}_modal_form`);
        let modal = bootstrap.Modal.getInstance(element);
        setTimeout(() => {
            if (modal === null) {
                modal = bootstrap.Modal.getInstance(element);
            }
        }, 100);
        if (options.onModalShow) {
            modal?.on('show.bs.modal', options.onModalShow);
        }
        let id;
        let submitUrl;
        $('body').on('click', '[data-bs-target="#' + name + '_modal"]', function () {
            id = $(this).data('app-id');
            if (options.submitDataGetUrlFromButton) {
                submitUrl = $(this).data('app-submit_url');
            }
            if (options.loadData) {
                let url = options.loadDataUrl;
                if (url === null) {
                    if (options.loadDataGetUrlFromButton) {
                        url = $(this).data('app-url');
                    }
                    else {
                        url = form.getAttribute('action').replace('ID', id);
                    }
                }
                if (options.loadDataUrlReplaceId) {
                    url = url.replace('ID', id);
                }
                let spinner = new Spinner();
                axios
                    .get(url)
                    .then(function (response) {
                    if (options.onLoadData) {
                        options.onLoadData(response, form);
                    }
                    if (options.loadDataMap != null) {
                        for (let object of options.loadDataMap) {
                            if (typeof _.get(response.data, object.fetched) != 'undefined') {
                                Common.fillFormElement(form, object.real, _.get(response.data, object.fetched));
                            }
                        }
                        if (options.loadDataMapWithRegular) {
                            for (let field in response.data?.data) {
                                Common.fillFormElement(form, field, response.data?.data[field]);
                            }
                        }
                    }
                    else {
                        for (let field in response.data?.data) {
                            Common.fillFormElement(form, field, response.data?.data[field]);
                        }
                    }
                    $(element).trigger('app.load-data');
                })
                    .catch(function (error) {
                    console.error(error);
                    let dataMessage = 'Wystąpił błąd podczas próby wykonania akcji.';
                    if (error && error.response) {
                        dataMessage = error.response.data.message;
                    }
                    Swal.fire({
                        text: dataMessage,
                        icon: 'error',
                        buttonsStyling: false,
                        reverseButtons: true,
                        confirmButtonText: 'Ok',
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                    }).then(() => {
                        modal.hide();
                    });
                })
                    .then(function () {
                    // Hide loading indication
                    spinner.destroy();
                });
            }
        });
        // Submit button handler
        const submitButton = element.querySelector('[data-app-' + name + '_modal-action="submit"]');
        submitButton.addEventListener('click', (e) => {
            e.preventDefault();
            if (!form.reportValidity()) {
                return;
            }
            let spinner = new Spinner();
            // Disable button to avoid multiple click
            submitButton.disabled = true;
            if (!submitUrl) {
                submitUrl = form.getAttribute('action').replace('ID', id);
            }
            let formData = new FormData(form);
            if (options.getCustomData) {
                formData = options.getCustomData(form);
            }
            axios
                .post(submitUrl, formData)
                .then(function (response) {
                modal.hide();
                form.reset();
                const message = response.data.message || options.successMessage;
                Swal.fire({
                    html: message,
                    icon: 'success',
                    buttonsStyling: false,
                    reverseButtons: true,
                    confirmButtonText: 'Ok',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                    },
                }).then(function (result) {
                    if (result.isConfirmed) {
                        options.onSuccess(response);
                    }
                });
            })
                .catch(function (error) {
                console.error(error);
                let dataMessage = 'Wystąpił błąd podczas próby wykonania akcji.';
                if (error && error.response) {
                    dataMessage = error.response.data.message;
                }
                if (error.response) {
                    Swal.fire({
                        text: dataMessage,
                        icon: 'error',
                        buttonsStyling: false,
                        reverseButtons: true,
                        confirmButtonText: 'Ok',
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                    });
                }
            })
                .then(function () {
                // Hide loading indication
                spinner.destroy();
                // Enable button
                submitButton.disabled = false;
            });
        });
        $(form).on('submit', function (e) {
            e.preventDefault();
            $(submitButton).click();
        });
        Common.setupModalCancelAlert(element, () => {
            form.reset();
        });
    },
    /**
     * Handle delete
     * @param {String} name
     * @param {Object} [options]
     * @param {Array} [options.urlExtraReplace] Array of extra replacements passed via app-url_replace_X="value"
     * @param {String} [options.successMessage] Success message
     * @param {String} [options.question] Question message
     * @param {Function} [options.onSuccess] On success callback
     */
    handleDelete: (name, options) => {
        options = Utils.setDefaults(options, {
            url: null,
            urlExtraReplace: [],
            question: 'Czy na pewno chcesz to zrobić?',
            successMessage: 'Pomyślnie wykonano polecenie!',
            onSuccess: () => {
                window.location.reload();
            },
        });
        $('body').on('click', '[data-app-' + name + '-action="delete"]', function () {
            let id = $(this).data('app-id');
            let url = options.url.replace('/ID', '/' + id);
            for (let replace of options.urlExtraReplace) {
                let value = $(this).data('app-url_replace_' + replace.toLowerCase());
                if (value) {
                    url = url.replace(replace, value);
                }
            }
            Swal.fire({
                text: options.question,
                icon: 'warning',
                showCancelButton: true,
                buttonsStyling: false,
                reverseButtons: true,
                confirmButtonText: 'Tak',
                cancelButtonText: 'Nie',
                customClass: {
                    cancelButton: 'btn btn-light-primary',
                    confirmButton: 'btn btn-warning',
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    let form = new FormData();
                    form.set('_method', 'DELETE');
                    let spinner = new Spinner();
                    axios
                        .post(url, form)
                        .then(function () {
                        Swal.fire({
                            text: options.successMessage,
                            icon: 'success',
                            buttonsStyling: false,
                            reverseButtons: true,
                            confirmButtonText: 'Ok',
                            customClass: {
                                confirmButton: 'btn btn-primary',
                            },
                        }).then(function (result) {
                            if (result.isConfirmed) {
                                options.onSuccess();
                            }
                        });
                    })
                        .catch(function (error) {
                        let dataMessage = error.response.data.message;
                        if (error.response) {
                            Swal.fire({
                                text: dataMessage,
                                icon: 'error',
                                buttonsStyling: false,
                                reverseButtons: true,
                                confirmButtonText: 'Ok',
                                customClass: {
                                    confirmButton: 'btn btn-primary',
                                },
                            });
                        }
                    })
                        .then(function () {
                        // Hide loading indication
                        spinner.destroy();
                    });
                }
            });
        });
    },
    handleErrorResponse: (error, message = 'Wystąpił błąd podczas próby wykonania akcji.', form = null) => {
        // if error is generic
        if (error && error.response) {
            message = error.response.data.message;
        }
        // if error is ApiErrorResponse
        if (error && error.success === false && error.message && error.errors) {
            message = error.message;
        }
        if (error) {
            ErrorSwal.fire({ text: message });
        }
        if (form !== null) {
            form = $(form);
            let errors = [];
            if (error) {
                if (error.success === false && error.message && error.errors) {
                    errors = error.errors;
                }
                else if (error.response && error.response.data.errors) {
                    errors = error.response.data.errors;
                }
            }
            for (const name in errors) {
                Common.addFormInputError(form, name, error.response.data.errors[name][0]);
            }
        }
    },
    findInputByName: (form, name) => {
        let input = form.find(`:input[name="${name}"]:not([type="hidden"])`);
        if (input.length == 0 && name.includes('.')) {
            const parts = name.split('.');
            name =
                parts[0] +
                    parts
                        .slice(1, parts.length)
                        .map((part) => `[${part}]`)
                        .join('');
            input = form.find(`:input[name="${name}"]:not([type="hidden"])`);
        }
        if (input.length == 0) {
            input = form.find(`[data-app-data_transfer="${name}"]`);
        }
        return input;
    },
    addFormInputError: (form, name, error) => {
        let input = Common.findInputByName(form, name);
        if (input.length == 0) {
            return;
        }
        input.addClass('is-invalid');
        let parent = input.closest('div');
        let errorDiv = parent.find('.invalid-feedback');
        if (!errorDiv.length) {
            errorDiv = $('<div class="invalid-feedback"></div>');
            if (input.hasClass('btn-check')) {
                input.closest('.btn-group').addClass('is-invalid').after(errorDiv);
            }
            else if (input.is('[type="checkbox"]') || input.is('[type="radio"]')) {
                input.closest('.form-check').find('.form-check-label').after(errorDiv);
            }
            else {
                input.after(errorDiv);
            }
        }
        errorDiv.text(error);
    },
    clearFormInputError: (form, name) => {
        const input = Common.findInputByName(form, name);
        if (input.hasClass('btn-check')) {
            input
                .closest('.btn-group')
                .removeClass('is-invalid')
                .find('.invalid-feedback')
                .remove();
        }
        else {
            input.removeClass('is-invalid');
            input.closest('div').find('.invalid-feedback').remove();
        }
    },
    changeFormInputRequirement: (form, name, state) => {
        const input = $(form).find(`[name="${name}"]`);
        input.prop('required', state);
        if (state) {
            if (input.closest('div').find('label').next('span.text-danger').length) {
                return;
            }
            input
                .closest('div')
                .find('label')
                .after(` <span class="text-danger">*</span>`);
        }
        else {
            input.closest('div').find('label').next('span.text-danger').remove();
        }
    },
    setFormInputHelpText: (form, name, text) => {
        const input = $(form).find(`[name="${name}"]`);
        if (text === null) {
            input.closest('div').find('.form-text').remove();
            return;
        }
        if (input.closest('div').find('.form-text').length) {
            return;
        }
        input
            .closest('div')
            .append(`<div id="${input.attr('id')}_help" class="form-text">${text}</div>`);
    },
    /**
     * Handle request
     * @param {String} name
     * @param {Object} [options]
     * @param {String} [options.url] Request url
     * @param {String} [options.method] Request method
     * @param {String} [options.successMessage] Success message
     * @param {String} [options.question] Question message
     * @param {Function} [options.onSuccess] On success callback
     */
    handleRequest: (name, options) => {
        options = Utils.setDefaults(options, {
            url: null,
            question: 'Czy na pewno chcesz to zrobić?',
            successMessage: 'Pomyślnie wykonano polecenie!',
            onSuccess: () => {
                window.location.reload();
            },
        });
        $('body').on('click', '[data-app-' + name + '-action="request"]', function () {
            let id = $(this).data('app-id');
            let url = options.url.replace('/ID', '/' + id);
            Swal.fire({
                text: options.question,
                icon: 'warning',
                buttonsStyling: false,
                showDenyButton: true,
                confirmButtonText: 'Tak',
                denyButtonText: 'Nie',
                customClass: {
                    denyButton: 'btn btn-light-primary',
                    confirmButton: 'btn btn-danger',
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    let form = new FormData();
                    form.set('_method', options.method ?? 'POST');
                    let spinner = new Spinner();
                    axios
                        .post(url, form)
                        .then(function () {
                        Swal.fire({
                            text: options.successMessage,
                            icon: 'success',
                            buttonsStyling: false,
                            reverseButtons: true,
                            confirmButtonText: 'Ok',
                            customClass: {
                                confirmButton: 'btn btn-primary',
                            },
                        }).then(function (result) {
                            if (result.isConfirmed) {
                                options.onSuccess();
                            }
                        });
                    })
                        .catch(function (error) {
                        let dataMessage = error.response.data.message;
                        if (error.response) {
                            Swal.fire({
                                text: dataMessage,
                                icon: 'error',
                                buttonsStyling: false,
                                reverseButtons: true,
                                confirmButtonText: 'Ok',
                                customClass: {
                                    confirmButton: 'btn btn-primary',
                                },
                            });
                        }
                    })
                        .then(function () {
                        // Hide loading indication
                        spinner.destroy();
                    });
                }
            });
        });
    },
    /**
     * Generate view from template
     * @param templateName
     * @param data
     * @deprecated
     * @returns {*|jQuery}
     */
    generateFromTemplate: (templateName, data = {}) => {
        let template = $(`[data-app-template="${templateName}"`);
        if (template.length === 0) {
            throw new Error('Template ' + templateName + ' not found');
        }
        let html = template.html();
        for (let property in data) {
            html = html.replaceAll(`{${property}}`, data[property]);
        }
        return html;
    },
    compileTemplate: (templateName, data = {}) => {
        const template = $(`[data-app-template="${templateName}"], template#${templateName}, [type="text/x-handlebars-template"][id=${templateName}]`);
        if (template.length === 0) {
            throw new Error('Template ' + templateName + ' not found');
        }
        const pattern = /{(\/)?([^}]+)}/g; // Matches any {content} or {/content}
        const templateString = template.html().replace(pattern, '{{$1$2}}');
        const compiled = Handlebars.compile(templateString);
        return compiled(data);
    },
    disableButton: (button = null) => {
        if (button === null) {
            button = $(document.activeElement);
        }
        if (button.length > 0 && button.is('button')) {
            button.attr('disabled', true);
            button.data('app-old_html', button.html());
            button.html(button.html() +
                `<span style="top: 1px;" class="position-relative ms-2 spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>`);
            return button;
        }
        return null;
    },
    enableButton: (button = null) => {
        if (button === null) {
            button = $(document.activeElement);
        }
        if (button.length > 0 && button.is('button')) {
            button.attr('disabled', false);
            button.html(button.data('app-old_html'));
            return button;
        }
    },
    /**
     * Submit form asynchronously
     * @param {any} form
     * @param {Object} [options]
     * @param {boolean} [options.spinner] Should show spinner
     * @param {boolean} [options.fillInputErrors]
     * @param {boolean} [options.lookForRedirects]
     * @param {String} [options.successMessage] Success message
     * @param {Function} [options.onSuccess] On success callback
     * @param {Function} [options.onError] On error callback
     * @param {boolean} [options.omitDefaultErrorBehaviour]
     * @param {boolean} [options.omitDefaultSuccessBehaviour]
     * @param {Array} [options.customButtons]
     */
    submitAsynchronously: (form, options) => {
        options = Utils.setDefaults(options, {
            spinner: false,
            fillInputErrors: false,
            lookForRedirects: true,
            onSuccess: () => { },
            onError: () => { },
            successMessage: 'Pomyślnie wykonano akcję',
            omitDefaultErrorBehaviour: false,
            omitDefaultSuccessBehaviour: false,
            customButtons: [],
        });
        form = $(form);
        let method = form.attr('method') ?? 'post';
        let url = form.attr('action');
        let data = new FormData(form[0]);
        let spinner = null;
        let submitButton = null;
        if (options.spinner) {
            spinner = new Spinner();
        }
        else {
            submitButton = form.find('button[type="submit"]');
            if (!submitButton.length) {
                submitButton = null;
            }
            submitButton = Common.disableButton(submitButton);
        }
        axios({
            method,
            url,
            data,
        })
            .then((response) => {
            if (typeof FormComponentHandler != 'undefined') {
                FormComponentHandler.releaseUnsubmittedForm($(form).attr('id'));
            }
            if (options.omitDefaultSuccessBehaviour !== true) {
                Swal.fire({
                    text: response.data.message ?? options.successMessage,
                    icon: 'success',
                    buttonsStyling: false,
                    reverseButtons: true,
                    confirmButtonText: 'Ok',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                    },
                }).then(function (result) {
                    if (result.isConfirmed) {
                        if (options.lookForRedirects) {
                            if (response.data.redirect) {
                                window.location = response.data.redirect;
                            }
                        }
                        else {
                            window.location.reload();
                        }
                    }
                });
                options.onSuccess(response);
                // todo: do it better
                if (options.customButtons.length) {
                    for (let button of options.customButtons) {
                        $('.swal2-actions').append(button);
                    }
                }
            }
            else {
                options.onSuccess(response);
            }
        })
            .catch((error) => {
            let dataMessage = 'Wystąpił błąd podczas próby wykonania akcji.';
            if (error && error.response) {
                dataMessage = error.response.data.message;
            }
            if (error.response && options.omitDefaultErrorBehaviour !== true) {
                Swal.fire({
                    text: dataMessage,
                    icon: 'error',
                    buttonsStyling: false,
                    reverseButtons: true,
                    confirmButtonText: 'Ok',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                    },
                });
                if (options.fillInputErrors && error.response.data.errors) {
                    for (let name in error.response.data.errors) {
                        Common.addFormInputError(form, name, error.response.data.errors[name][0]);
                    }
                }
            }
            options.onError(error);
        })
            .finally(() => {
            if (spinner !== null) {
                spinner.destroy();
            }
            else if (submitButton) {
                Common.enableButton(submitButton);
            }
        });
    },
    handleNavRemember: (id) => {
        const nav = $(`[data-app-nav_remember="${id}"`);
        if (!nav.length) {
            return;
        }
        let storageKey = 'nav-remember-' + id;
        let current = Cookies.get(storageKey);
        if (!current) {
            current = nav.find('li button.nav-link').attr('id');
        }
        if (!current) {
            return;
        }
        const button = nav.find(`li button.nav-link[id="${current}"]`);
        button.trigger('click');
        nav.find('li button.nav-link').on('click', function () {
            let id = $(this).attr('id');
            Cookies.set(storageKey, id, {
                secure: true,
                sameSite: 'Lax',
                expires: 356,
            });
        });
    },
    openModal: (modal) => {
        const modalObject = Modal.getOrCreateInstance($(modal)[0]);
        modalObject.show();
    },
    closeModal: (modal) => {
        const modalObject = Modal.getOrCreateInstance($(modal)[0]);
        modalObject.hide();
    },
};
export default Common;
